import script from "./ArrayParam.vue?vue&type=script&setup=true&lang=js"
export * from "./ArrayParam.vue?vue&type=script&setup=true&lang=js"

import "./ArrayParam.vue?vue&type=style&index=0&id=1f9110ad&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f9110ad"]])

export default __exports__